"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asInverted = exports.asEmpty = exports.serializeArray = exports.isEmpty = void 0;

var isEmpty = function isEmpty(v) {
  return v === undefined || v === null || v === 'undefined' || v === 'null' || typeof v === 'string' && !v.length || Array.isArray(v) && !v.length;
};

exports.isEmpty = isEmpty;

var serializeArray = function serializeArray(v) {
  return Array.isArray(v) ? v.join(',') : v;
};

exports.serializeArray = serializeArray;

var asEmpty = function asEmpty(v) {
  return v === '*' || v === '!*' ? '' : v;
};

exports.asEmpty = asEmpty;

var asInverted = function asInverted(key, v) {
  return v === '!*' ? "!".concat(key) : key;
};

exports.asInverted = asInverted;